import { object } from 'common/helpers'


export const initialState = {
  size: 0,
  price: 0,
  date: null,
  email: '',
  name: '',
  gender: '',
  message: '',
  giftSizes: [],
}

export const setDate = (state, payload) => (
  object.set(state, 'date', payload)
)

export const setGender = (state, payload) => (
  object.set(state, 'gender', payload)
)

export const setGiftSizes = (state, payload) => (
  object.set(state, 'giftSizes', payload)
)

export const setGiftParams = (state, { size, price }) => (
  object.merge(state, { size, price })
)

export const setPerson = (state, { name, email, message }) => (
  object.merge(state, { name, email, message })
)

export const reset = () => initialState
